import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "@/hooks/apiFetch"

export type AuditSummary = {
  total_items: number
  matched: number
  mismatched: number
  missing_in_system: number
  missing_in_physical: number
}

export type AuditResult = {
  id: number
  sku: string
  system_qty: number
  physical_qty: number
  difference: number
  status: string
}

export type StockAuditDetailResponse = {
  data: {
    audit: {
      id: number
      status: string
      created_at: string
      completed_at: string
    }
    summary: AuditSummary
    results: AuditResult[]
  }
}

const fetchStockAuditDetail = async (id: string) => {
  return apiFetch<StockAuditDetailResponse>(`stock-audit/${id}`)
}

export const useStockAuditDetail = (id?: string) => {
  return useQuery({
    queryKey: ["stock-audit-detail", id],
    queryFn: () => fetchStockAuditDetail(id!),
    enabled: !!id,
    refetchInterval: (query) => {
      const audit = query.state.data?.data?.audit

      return audit?.status === "processing" ? 3000 : false
    },
  })
}
